import PendingApplications from "../Administration/PendingApplications";

const FirePendingApplications = ({ role }) => {
  return (
    <>
      <PendingApplications role={role} />
    </>
  );
};

export default FirePendingApplications;
